export default {

    brenntag: {
        primary: '#000066',
        secondary: '#cc0033',
        grey: '#999999',
        backgroundColor: '#f5f2ea',
        dividerColor: '#dddddd',
        textColor: '#303030',
        borderColor: '#777777'
    },
    bcd: {
        primary: '#e84b04',
        secondary: '#585858',
        grey: '#999999',
        backgroundColor: '#f0f0f0',
        dividerColor: '#dddddd',
        textColor: '#222222',
        borderColor: '#cccccc'
    }
}